// Created by Weverton Couto
// on 23/10/2025
// for Techmatic Solutions
// using Odoo 17.0

import React from 'react';

const MetricCard = ({ titulo, valor, icone, variacao, comparacao, cor = 'primary' }) => {
    const formatarValor = (val) => {
        if (typeof val === 'number') {
            return val.toLocaleString('pt-BR');
        }
        return val;
    };

    const getVariacaoClass = () => {
        if (!variacao && variacao !== 0) return 'neutral';
        return variacao >= 0 ? 'positive' : 'negative';
    };

    const getVariacaoIcon = () => {
        if (!variacao && variacao !== 0) return 'fas fa-minus';
        return variacao >= 0 ? 'fas fa-arrow-up' : 'fas fa-arrow-down';
    };

    const getVariacaoText = () => {
        if (variacao === null || variacao === undefined) return 'Sem comparação';
        const sinal = variacao >= 0 ? '+' : '';
        return `${sinal}${variacao.toFixed(1)}%`;
    };

    return (
        <div className="metric-card">
            <div className="metric-card-header">
                <p className="metric-label">{titulo}</p>
                <div className="metric-icon">
                    <i className={icone}></i>
                </div>
            </div>
            <h3 className="metric-value">{formatarValor(valor)}</h3>
            <div className="metric-footer">
                <span className={`metric-badge ${getVariacaoClass()}`}>
                    <i className={getVariacaoIcon()}></i>
                    {getVariacaoText()}
                </span>
                {comparacao && (
                    <span className="metric-comparison">{comparacao}</span>
                )}
            </div>
        </div>
    );
};

export default MetricCard;

